import { useState } from 'react';
import { useMessageGetter } from '@messageformat/react';
import { useFormValidationAlert } from '@op/luna.yaweb-common-js/FormValidationAlert';

import { 
  FormRow, 
  useLocale, 
  ValidInput 
} from '@op/opds.opux';

import Valid, { 
  getErrorMessage, 
  ValidateError 
} from '@op/opds.validate';

import { 
  validateString, 
  validateAlphaNumericInput,
  ErrorCode,
  validateEmailwithTLD,
  validateStringwithoutSP,
  validatePropertyCode,
  validateYear,
  validateNumeric,
  validateSport
} from './validators';


const Validation = {
  ...Valid,
  year: {
    validate: validateYear, 
    pretty: str => str   
  },
  alphaNumeric: { 
    validate: validateAlphaNumericInput, 
    pretty: str => str 
  },
  string: { 
    validate: validateString, 
    pretty: str => str 
  },
  numeric:{
    validate: validateNumeric,
    pretty: str => str
  },
  email: {
    validate: validateEmailwithTLD, 
    pretty: str => str 
  },
  stringwithoutSP: {
    validate: validateStringwithoutSP, 
    pretty: str => str 
  },
  propertycode:{
    validate: validatePropertyCode,
    pretty: str => str
  },
  sport:{
    validate: validateSport,
    pretty: str => str
  }
};

export const FormInput = ({
  value = '',
  maxLength,
  unitPos,
  inputId,
  label,
  type,
  required,
  onChange,
  hint,
  unit,
  limit,
  submitted,
  autoComplete,
  onBlur
}) => {
  const locale = useLocale();
  const getMessage = useMessageGetter('');
  const { errors, isVisible, removeErrors } = useFormValidationAlert();
  const [error, setError] = useState(null);
  const [isDirty, setIsDirty] = useState(false);

  const { pretty, validate } = Validation[type];
  const errorCombined = (isVisible || submitted) && errors.find(e => e.id === inputId);

  const onInputChange = (value, err) => {
    if (errorCombined) {
      removeErrors(inputId);
    }
    setError(err);
    onChange(value, err);
  };

  const getError = () => {
    if (!required && !value) {
      return null;
    }

    if (error || errorCombined) {
      const errorMsg = validate(value);
      if (errorMsg instanceof ValidateError) {
        return getErrorMessage(locale, errorMsg);
      }
      if (errorMsg instanceof ErrorCode) {
        return getMessage(errorMsg.code);
      }
    }
    if (error instanceof ValidateError) {
      return getErrorMessage(locale, error.code)
    }
    return error;
  };

  return (
    <FormRow 
      label={label} 
      labelFor={inputId} 
      required={required} 
      hint={hint}
    >
      <ValidInput
        type="text"
        data-id={inputId}
        error={(isDirty || errorCombined) && getError()}
        value={value}
        onChange={(_ev, val, error) => onInputChange(val, error)}
        onBlur={(ev) => {
          setIsDirty(true)
          onBlur?.(ev)
        }}
        validate={(data) => validate(data, limit)}
        pretty={pretty}
        unit={unit}
        maxLength={maxLength}
        unitPos={unitPos}
        autoComplete={autoComplete}
      />
    </FormRow>
  );
};

FormInput.displayName = 'FormInput';